/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

(function() {
    //Main module definition.
  define({

      load: function (name, req, onload, config) {
        // transformed is:
        var internalName = "components/" + name + "/js/" + name;
        // console.log(internalName);
        req([internalName], function (value) {
             //  console.log("loaded ");
              onload(value);
          });
      }
  });

}());
